<template>
  <div id="introduction" class="panel active">
    <div class="panel-header"></div>
    <div class="panel-content px-xs-4 px-md-0">
      <div class="hr-end">
        <img src="/files/images/eu/signs_of_sma_turquoise.svg" class="d-block sma-logo mb-xs-30" :alt="$getString('GLOBAL_SIGNS_OF_SMA')">

        <h1 v-html="$getString('GLOBAL_SIGNS_OF_A_MOTOR_DELAY')"></h1>
        <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
        <h2 class="mb-xs-4" v-html="$getString('INTRODUCTION_CHILD_PROGRESS')"></h2>
        <h3 class="mb-xs-2" v-html="$getString('INTRODUCTION_DEVELOP_DIFFERENTLY')"></h3>
        <p
          v-for="(line, index) in $getString('INTRODUCTION_BODY_ARRAY')"
          :key="index"
          class="mb-xs-2"
          v-html="line"
        ></p>

        <div class="buttons my-xs-20">
          <div class="tool-button next" @click="onStart" v-html="$getString('GLOBAL_BUTTON_START')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StageIntroduction',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      handlers: [],
    }
  },
  methods: {
    onStart() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": '{page_label}_Questionnaire_start',
      } });
      this.$emit('action', { type: 'increment-page' });
      this.$emit('action', { type: 'goto-stage', data: 'age-select' });
    },
  },
}
</script>
